import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { LanguageType } from '../../constants/Languages';
import Text from '../global/Text';
import QuestionnaireAttachmentButton from './QuestionnaireAttachmentButton';
import SelectedAttachmentTile from './SelectedAttachmentTile';
import VideoPicker from './VideoPicker';

const VideoIcon = require('../../assets/icons/take-video.png');

type AddVideoProps = {
  source: string | undefined;
  language: LanguageType;
  isValid?: boolean;
  onRecordVideo: () => void;
  onPlaybackVideo: (source: string) => void;
} & WithTranslation;

// Simple placeholder to add and preview photo
// Also functions as a button to activate the camera
export class AddVideo extends React.Component<AddVideoProps> {
  getFileName = (source: string) => {
    const extractedName = source.split('/').pop()?.split('?')[0] || source;

    try {
      return decodeURIComponent(extractedName);
    } catch (_err) {
      return extractedName;
    }
  };

  handlePressNew = () => this.props.onRecordVideo!();

  handlePressEdit = (source: string) => {
    if (source) {
      this.props.onPlaybackVideo(source);
    }
  };

  render() {
    const { source, isValid, t } = this.props;
    return !source ? (
      <VideoPicker onComplete={this.props.onRecordVideo} testID="new-video">
        <QuestionnaireAttachmentButton
          accessibilityLabel={t('questionnaire:addVideo')}
          iconSource={VideoIcon.default}
          invalid={isValid === false}
          label={t('questionnaire:addVideo')}
        />
      </VideoPicker>
    ) : (
      <SelectedAttachmentTile
        accessibilityLabel={t('questionnaire:prompt.editVideo')}
        fileName={this.getFileName(source)}
        kind="video"
        onPress={() => this.handlePressEdit(source)}
        testID={'edit-video'}
      />
    );
  }
}

const Touchable: any = TouchableOpacity;

const styles = StyleSheet.create({
  portraitBox: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 80,
    height: (62 / 3) * 4 + 4,
    marginVertical: 10,
    marginHorizontal: 2,
    borderRadius: 5,
    borderWidth: 2,
    borderColor: '#efeeed',
    backgroundColor: '#efeeed'
  },
  portraitBoxVideo: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 200,
    height: (62 / 3) * 4 + 4,
    marginVertical: 10,
    marginHorizontal: 2,
    borderRadius: 5,
    borderWidth: 2,
    borderColor: '#efeeed',
    backgroundColor: '#efeeed'
  },
  landscapeBox: {
    justifyContent: 'center',
    alignItems: 'center',
    width: (62 / 3) * 4 + 4,
    height: 80,
    marginVertical: 10,
    marginHorizontal: 2,
    borderRadius: 5,
    borderWidth: 2,
    borderColor: '#efeeed',
    backgroundColor: '#efeeed'
  },
  subtitle: {
    textAlign: 'center',
    fontSize: 14,
    lineHeight: 18
  },
  videoOverlay: {
    position: 'absolute',
    borderRadius: 2,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    // backgroundColor: '#000',
    opacity: 0.5
  },
  playButtonContainer: {
    position: 'absolute',
    borderRadius: 2,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
    zIndex: 10
  },
  playButtonIcon: {
    width: '100%',
    height: '100%',
    overflow: 'visible'
  },
  invalid: {
    borderColor: '#ff6f00'
  },
  photo: {
    flex: 1,
    width: '100%',
    borderRadius: 2
  },
  innerBox: {
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  errorText: {
    marginTop: 5,
    fontSize: 12,
    lineHeight: 12.5,
    textAlign: 'center',
    color: '#FA6161'
  },
  progressText: {
    marginTop: 5,
    fontSize: 12,
    lineHeight: 12.5,
    textAlign: 'center',
    color: '#3cd070'
  }
});

export default withTranslation(['questionnaire'])(AddVideo);
